// "use strict";
import { OLabApiQuestion } from "./OLabApiQuestion";

export class OLabApiTextQuestion extends OLabApiQuestion {
  constructor(clientApi, id) {
    super(clientApi, id);
  }
}
